import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import { retryPaymentPayout } from "api/payments";
import React from "react";
import { toast } from "react-hot-toast";
import { MdHighlightOff, MdOutlineRefresh } from "react-icons/md";
import { convertToFloat } from "utils/formatNumber";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";
import { PAYOUT_PANEL_STYLES } from "./InfoModal";

const RetryModal = ({
  info, fetchPayments, transactionID, varient, enRefund, client_is_deleted,
}: {
  info?: any; fetchPayments: () => void; transactionID: string;
  varient?: string; enRefund?: any; client_is_deleted?: boolean;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = React.useState<boolean>();
  const [isCloseModal, setIsCloseModal] = React.useState(false);

  const handleClose = () => {
    setIsCloseModal(true);
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 300);
  };

  const isDisabled =
    client_is_deleted || info?.client === "Banwire" || info?.id?.includes("payout") ||
    ["REFUNDED","REJECTED","CREATED","AUTHORIZED","PENDING","CAPTURED","APPROVED",
     "CHARGEBACK","ALERTED","HELD","DUPLICATE","DISPUTE","REFUND DECLINED"].includes(info?.status);

  async function handleRetry() {
    setIsLoading(true);
    retryPaymentPayout({ internal_id: transactionID }, null)
      .then((resp: any) => {
        if (resp?.status) toast.success("Payment created successfully");
        else toast.error("Unable to do this transaction");
        onClose(); fetchPayments();
      })
      .catch((err: any) => {
        const Gerror = err?.response?.data?.message || err?.response?.data?.error;
        toast.error(Gerror ?? "Unable to do this transaction");
      })
      .finally(() => setIsLoading(false));
  }

  return (
    <>
      <Popover trigger="hover" placement="bottom">
        <PopoverTrigger>
          <span className="inline-flex">
            <button className="txn-action-btn" onClick={onOpen} disabled={isDisabled} aria-label="Retry payout">
              <MdOutlineRefresh size={14} />
            </button>
          </span>
        </PopoverTrigger>
        <PopoverContent border="1px solid #fde68a" borderRadius="12px" bg="#fffbeb" maxW="180px" p="0" overflow="hidden" zIndex="20">
          <PopoverHeader bg="#fef3c7" fontSize="12px" fontWeight="700" color="#92400e" borderBottom="1px solid #fde68a" px="12px" py="9px">Retry Payout</PopoverHeader>
          <PopoverArrow bg="#fffbeb" />
        </PopoverContent>
      </Popover>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div className={`pconfirm-panel${isOpen && !isCloseModal ? " pconfirm-panel--open" : " pconfirm-panel--close"}`}>
          <div className="pconfirm-glow pconfirm-glow--amber" />
          <div className="pconfirm-header pconfirm-header--amber">
            <div className="pconfirm-header-brand">
              <div className="pconfirm-header-logo">
                <MdOutlineRefresh size={20} color="#fff" />
              </div>
              <div>
                <h2 className="pconfirm-title">Retry Payout</h2>
                <p className="pconfirm-sub">Re-attempt the transaction</p>
              </div>
            </div>
            <button className="pconfirm-close" onClick={handleClose}><MdHighlightOff size={22} /></button>
          </div>

          <div className="pconfirm-body">
            <div className="pconfirm-info-card">
              <div className="pconfirm-info-row">
                <span className="pconfirm-info-key">Internal ID</span>
                <span className="pconfirm-info-val">{info?.id || "—"}</span>
              </div>
              <div className="pconfirm-info-row">
                <span className="pconfirm-info-key">Amount</span>
                <span className="pconfirm-info-val pconfirm-info-val--amount">
                  {convertToFloat(info?.amount)} {info?.currency}
                </span>
              </div>
            </div>
            <p className="pconfirm-question">
              This will retry the failed payout. The payment will be attempted again using the original details. Do you want to continue?
            </p>
          </div>

          <div className="pconfirm-footer">
            <button className="pconfirm-btn-cancel" onClick={handleClose}>Cancel</button>
            <button
              className="pconfirm-btn-action--amber"
              onClick={handleRetry}
              disabled={!!isLoading || client_is_deleted}
            >
              {isLoading ? <span className="pconfirm-spinner" /> : <><MdOutlineRefresh size={14} />Retry</>}
            </button>
          </div>
        </div>
      </Modal>

      {PAYOUT_PANEL_STYLES}
    </>
  );
};

export default RetryModal;